import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zoomout",
  "use": "icon-zoomout-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zoomout\"><path d=\"M607.516 665.543a256 256 0 10-362.154-362.04 256 256 0 00362.154 362.04zm241.21 200.306a28.444 28.444 0 01-40.221 40.22L627.143 724.708a312.889 312.889 0 1140.164-40.278l181.418 181.42zM343.95 455.11a28.444 28.444 0 000 56.889h170.667a28.444 28.444 0 000-56.889H343.95z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol